import React, { useEffect, useState } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Autocomplete,
    Avatar,
    Box,
    Button,
    ButtonBase,
    CardActions,
    CardContent,
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    InputBase,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Paper,
    Skeleton,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/TotalGrowthBarChart';
import { gridSpacing } from 'store/constant';
import ApiLink from 'API';
import axios from 'axios';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from 'react-router';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import moment from 'moment';
import { exportToCSV } from 'ui-component/exportToCSV';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const StockCard = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(false);
    const [SumCount, setSumCount] = useState(0);
    const [Value, setValue] = useState('');
    const [Data, setData] = useState([]);
    const [Datasearch, setDatasearch] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [DataLocation, setDataLocation] = useState([{ locationCode: '^', Name: 'ALL' }]);
    const [SelectLocation, setSelectLocation] = useState({ locationCode: '^', Name: 'ALL' });
    const [open, setOpen] = React.useState(false);
    const [loading, setloading] = React.useState(false);
    const [DateFilterInventory, setDateFilterInventory] = useState(new Date());

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChangeDateFilterInventory = (value) => {
        setDateFilterInventory(value);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        let isMounted = true;

        const LoadDataLocation = async () => {
            try {
                setloading(true);
                const response = await axios.get(ApiLink + '/api/consignment/all/^', {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                });
                if (isMounted) {
                    if (response.status === 200) {
                        const data = [{ locationCode: '^', Name: 'ALL' }];
                        setDataLocation(data.concat(response.data.data || []));
                        setloading(false);
                    } else if (response.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            } catch (error) {
                if (isMounted) {
                    setloading(false);
                    if (error?.response?.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            }
        };

        const LoadData = async () => {
            try {
                setisLoading(true);
                const response = await axios.get(ApiLink + '/api/dashboard/sale/inventory', {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                });
                if (isMounted) {
                    if (response.status === 200) {
                        const responseData = response.data.data || [];
                        setDatasearch(responseData);
                        setData(responseData);
                        const SumValue = responseData.map((item) => item.qty || 0).reduce((prev, next) => prev + next, 0);
                        setSumCount(SumValue);
                        setisLoading(false);
                    } else if (response.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            } catch (error) {
                if (isMounted) {
                    setisLoading(false);
                    if (error?.response?.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            }
        };

        LoadDataLocation();
        LoadData();

        return () => { isMounted = false; };
    }, []);

    const LoadDataFilterDate = async (value) => {
        setAnchorEl(null);
        try {
            setisLoading(true);
            const response = await axios.get(
                ApiLink + '/api/dashboard/sale/inventory/filter/' + value.Location + '/' + new Date(value.Datevalue),
                {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                }
            );
            if (response.status === 200) {
                const responseData = response.data.data || [];
                setDatasearch(responseData);
                setData(responseData);
                const SumValue = responseData.map((item) => item.qty || 0).reduce((prev, next) => prev + next, 0);
                setSumCount(SumValue);
                setisLoading(false);
            } else if (response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            setisLoading(false);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    };

    const ExportEachItem = async () => {
        setAnchorEl(null);
        try {
            setisLoading(true);
            const response = await axios.get(
                ApiLink + '/api/dashboard/export/inventory/filter/' + SelectLocation.locationCode + '/' + new Date(DateFilterInventory),
                {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                }
            );
            if (response.status === 200) {
                const filename = 'Inventory-Aone-each-item-' + SelectLocation?.Name + '-' + moment(DateFilterInventory).format('YYYY-MM-DD-HH:mm:ss');
                if (response.data.data && response.data.data.length > 0) {
                    const transformedData = response.data.data.flatMap((product) =>
                        (product.stockcontrollers || []).map((stock) => ({
                            _id: stock._id,
                            productId: stock.productId,
                            model: product.model,
                            productName: product.productName,
                            color: product.color,
                            imei: stock.imei,
                            agentID: stock.agentID,
                            importPrice: stock.importPrice,
                            salePrice: stock.salePrice,
                            rateImport: stock.rateImport,
                            importDate: moment(stock.importDate).format('DD-MM-yyyy HH:mm'),
                            receiptNumber: stock.receiptNumber,
                            referenceInvoice: stock?.referenceInvoice,
                            branchCode: stock.branchCode,
                            CurrentlocationCode: stock.CurrentlocationCode,
                            type: stock.type,
                            locationCode: stock.locationCode
                        }))
                    );
                    exportToCSV(transformedData, filename);
                }
                setisLoading(false);
            } else if (response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            setisLoading(false);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    };

    useEffect(() => {
        if (Value !== '') {
            const data = Data.filter(
                (item) =>
                    item.productName.toLowerCase().includes(Value.toLowerCase()) ||
                    item.productId.toLowerCase().includes(Value.toLowerCase()) ||
                    item.model.toLowerCase().includes(Value.toLowerCase())
            );
            setDatasearch(data);
        } else {
            setDatasearch(Data);
        }
    }, [Value, Data]);

    if (isLoading) {
        return (
            <MainCard content={false} sx={{ height: 'calc(100vh - 280px)', minHeight: 480, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <CardContent sx={{ flex: 1 }}>
                    <Stack spacing={1.5}>
                        <Skeleton variant="text" width="40%" height={28} />
                        <Skeleton variant="rectangular" height={20} />
                        {[...Array(8)].map((_, i) => (
                            <Stack key={i} direction="row" spacing={2} alignItems="center">
                                <Skeleton variant="rectangular" width={40} height={40} />
                                <Stack sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width="70%" />
                                    <Skeleton variant="text" width="40%" />
                                </Stack>
                                <Skeleton variant="text" width={50} />
                            </Stack>
                        ))}
                    </Stack>
                </CardContent>
            </MainCard>
        );
    }

    return (
        <MainCard content={false} sx={{ height: 'calc(100vh - 280px)', minHeight: 480, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <CardContent>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Grid container alignContent="center" justifyContent="space-between">
                                    <Grid item>
                                        <Stack direction="row-reverse">
                                            <MoreHorizOutlinedIcon
                                                fontSize="small"
                                                sx={{ color: theme.palette.primary[200], cursor: 'pointer' }}
                                                aria-controls="menu-popular-card"
                                                aria-haspopup="true"
                                                onClick={handleClick}
                                            />
                                            <Menu
                                                id="menu-popular-card"
                                                anchorEl={anchorEl}
                                                keepMounted
                                                open={Boolean(anchorEl)}
                                                onClose={handleClose}
                                                variant="selectedMenu"
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            >
                                                <MenuItem
                                                    key={1}
                                                    onClick={async () => {
                                                        setAnchorEl(null);
                                                        const filename = 'Inventory-Aone-' + SelectLocation?.Name + '-' + moment(DateFilterInventory).format('YYYY-MM-DD-HH:mm:ss');
                                                        const dataExcel = Datasearch.map((item) => ({
                                                            productId: item.productId,
                                                            productName: item.productName,
                                                            model: item.model,
                                                            color: item.color,
                                                            branchCode: item.branchCode,
                                                            qty: item.qty,
                                                            importPrice: item.importPrice,
                                                            rateImport: item.qty > 0 ? Number(item.rateImport) / Number(item.qty) : 0,
                                                            salePrice: item.salePrice
                                                        }));
                                                        exportToCSV(dataExcel, filename);
                                                    }}
                                                >
                                                    <ListItemIcon><ArticleIcon fontSize="small" color="success" /></ListItemIcon>
                                                    <ListItemText>Export Excel</ListItemText>
                                                </MenuItem>
                                                <MenuItem key={2} onClick={ExportEachItem}>
                                                    <ListItemIcon><ArticleIcon fontSize="small" color="primary" /></ListItemIcon>
                                                    <ListItemText>Export Each Item</ListItemText>
                                                </MenuItem>
                                                <MenuItem>
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <MobileDateTimePicker
                                                            label="Inventory Date"
                                                            inputFormat="DD-MM-YYYY HH:mm:ss"
                                                            value={DateFilterInventory}
                                                            onChange={handleChangeDateFilterInventory}
                                                            onAccept={() => LoadDataFilterDate({ Datevalue: DateFilterInventory, Location: SelectLocation.locationCode })}
                                                            renderInput={(params) => <TextField size="small" {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </MenuItem>
                                                <MenuItem>
                                                    <Autocomplete
                                                        size="small"
                                                        id="locationCode"
                                                        sx={{ minWidth: 300 }}
                                                        defaultValue={SelectLocation}
                                                        onChange={(event, newValue) => {
                                                            const loc = newValue || { locationCode: '^', Name: 'ALL' };
                                                            setSelectLocation(loc);
                                                            LoadDataFilterDate({ Datevalue: DateFilterInventory, Location: loc.locationCode });
                                                        }}
                                                        open={open}
                                                        onOpen={() => setOpen(true)}
                                                        onClose={() => setOpen(false)}
                                                        getOptionLabel={(option) => option.locationCode + '(' + option.Name + ')'}
                                                        options={DataLocation}
                                                        loading={loading}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                size="small"
                                                                label="Location"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <React.Fragment>
                                                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </React.Fragment>
                                                                    ),
                                                                    startAdornment: (
                                                                        <InputAdornment position="start"><LocationOnIcon /></InputAdornment>
                                                                    )
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </MenuItem>
                                            </Menu>
                                            <Typography variant="h4">Inventory{'(' + SumCount + ')'}</Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid item>
                                        <Box>
                                            <Paper sx={{ display: 'flex', width: 200 }} elevation={2}>
                                                <InputBase
                                                    fullWidth
                                                    style={{ marginLeft: 8, flex: 1 }}
                                                    value={Value}
                                                    onChange={(e) => setValue(e.target.value)}
                                                    placeholder="Search..."
                                                    startAdornment={
                                                        <IconButton onClick={() => setValue('')} size="small"><RefreshIcon /></IconButton>
                                                    }
                                                />
                                            </Paper>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <PerfectScrollbar
                                    options={{ suppressScrollX: true }}
                                    style={{ height: '100%', maxHeight: 'calc(100vh - 380px)', minHeight: 320, overflowX: 'hidden' }}
                                >
                                    {Datasearch.map((item, index) => (
                                        <div key={index}>
                                            <Grid container direction="column" spacing={1}>
                                                <Grid item>
                                                    <Avatar variant="rounded" src={item?.images?.[0]?.img} sx={{ width: 40, height: 40, ml: 2 }} />
                                                </Grid>
                                                <Grid item>
                                                    <Grid container alignItems="center" justifyContent="space-between">
                                                        <Grid item><Typography variant="subtitle1">{item.productName + ' (' + item.color + ')'}</Typography></Grid>
                                                        <Grid item><Typography variant="h3">{item.qty}</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <Grid container alignItems="center" justifyContent="space-between">
                                                        <Grid item><Typography variant="subtitle2" sx={{ color: 'success.dark' }}>{item.model}</Typography></Grid>
                                                        <Grid item><Typography variant="subtitle2" sx={{ color: 'error.dark' }}>{'Order: ' + (item.requestproducts?.order || 0)}</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Divider sx={{ my: 1.5 }} />
                                        </div>
                                    ))}
                                </PerfectScrollbar>
                            </Grid>
                        </Grid>
                    </CardContent>
        </MainCard>
    );
};

export default StockCard;
